import { useQuery } from '@apollo/client';
import { isNil } from '@sixfold/typed-primitives';
import { useParams } from 'react-router';

import { InfiniteScroll } from '../../components/infinitescroll';
import {
  getNodes,
  CompanyUserGroupOnPlatformQuery,
  CompanyUserGroupOnPlatformQueryVariables,
  PAGINATION_PAGE_SIZE,
  loadMoreFromConnection,
} from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { UserGroupOnPlatformView } from '../components/user_group_on_platform';
import { UserGroupOnPlatform } from '../entities';
import { companyUserGroupQuery } from '../graphql';

class LoadingContainer extends Loader<
  CompanyUserGroupOnPlatformQuery,
  UserGroupOnPlatform | undefined,
  CompanyUserGroupOnPlatformQueryVariables
> {}

export const CompanyUserGroupContainer = () => {
  const { company_id, group_id } = useParams() as { company_id: string; group_id: string };

  const result = useQuery<CompanyUserGroupOnPlatformQuery, CompanyUserGroupOnPlatformQueryVariables>(
    companyUserGroupQuery,
    {
      variables: {
        limit: PAGINATION_PAGE_SIZE,
        company_id,
        group_id,
      },
    },
  );

  return (
    <LoadingContainer
      result={result}
      mapData={({ data }) => {
        if (isNil(data.company) || isNil(data.company.userGroupOnPlatform)) {
          return undefined;
        }

        return {
          ...data.company.userGroupOnPlatform,
          company: data.company?.userGroupOnPlatform.company ?? undefined,
          users: getNodes(data.company.userGroupOnPlatform.users) ?? [],
        };
      }}>
      {(userGroupOnPlatform) => {
        if (userGroupOnPlatform === undefined) {
          return 'No such group';
        }

        return (
          <InfiniteScroll
            triggerOnWindow={false}
            loadMoreEntries={() =>
              loadMoreFromConnection(companyUserGroupQuery, result, ['company', 'userGroupOnPlatform', 'users'])
            }>
            <UserGroupOnPlatformView userGroupOnPlatform={userGroupOnPlatform} />
          </InfiniteScroll>
        );
      }}
    </LoadingContainer>
  );
};
